import { COOKIE_SESSION_ID } from '@config/constants'

import { getCorrelationId, refreshCorrelationIdCookie } from './helpers'

export const getSessionId = (cookies) =>
  getCorrelationId(cookies, COOKIE_SESSION_ID)

export const refreshSessionIdCookie = (sessionId, res) => {
  refreshCorrelationIdCookie(COOKIE_SESSION_ID, sessionId, res)
}
